import { NumberDecimalSeparator } from '@common/modelDefinition';
import useStore from '@data/state/zustand';

export const formatNumber = (value: number | string) => {
    const otherSettings = useStore.getState().otherSettings;
    const locale = otherSettings?.numberDecimalSeparator ? otherSettings?.numberDecimalSeparator : 'en-US';
    const number = Number(value);
    // Koristimo Intl.NumberFormat koji automatski odabire separator prema locale
    // console.log('number', number);
    const options = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    return new Intl.NumberFormat(locale, options).format(number);
};

export const parseFormattedNumber = (formatted: any) => {
    const otherSettings = useStore.getState().otherSettings;
    const locale = otherSettings?.numberDecimalSeparator ? otherSettings?.numberDecimalSeparator : 'en-US';

    if (typeof formatted === 'number') {
        return formatted; // Ako je već broj, vrati ga direktno
    }

    if (typeof formatted === 'string') {
        // Normaliziraj unos na osnovu trenutnog lokalnog formata
        if (locale === NumberDecimalSeparator.cooma) {
            // Ako je separator zarez, pretvori '.' u ',' ako se koristi za decimalni broj
            if (formatted.includes('.')) {
                const parts = formatted.split('.');
                if (parts.length === 2 && /^\d+$/.test(parts[1])) {
                    formatted = parts[0].replace(/,/g, '') + ',' + parts[1];
                }
            }
            formatted = formatted.replace(/\./g, '').replace(',', '.');
        } else if (locale === NumberDecimalSeparator.dot) {
            // Ako je točka odabrana kao decimalni separator
            // Provjeri je li korisnik koristio ',' umjesto '.'
            if (formatted.includes(',')) {
                const parts = formatted.split(',');
                if (parts.length === 2 && /^\d+$/.test(parts[1])) {
                    formatted = parts[0].replace(/\./g, '') + '.' + parts[1];
                }
            }
            // Ukloni sve ',' koji označavaju tisućice
            formatted = formatted.replace(/,/g, '');
        }
    }

    const parsed = Number(formatted);
    return isNaN(parsed) ? 0 : parsed;
};